export default function Icon(props) {
  return <img src={props.icon} alt="rails icon" className="w-8 mr-2 bg-opacity-80 bg-white rounded" />;
}
